import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useRouteMatch } from 'react-router';

const EmployeeDetailsPage = ({ route }) => {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.push(
        `/app/registry/employees/${match.params.employeeId}/personal`,
      );
    }
  }, [match]);

  return null;
};

EmployeeDetailsPage.propTypes = {
  route: PropTypes.object.isRequired,
};

export default EmployeeDetailsPage;
